const level = 16;
const Slot = {
  path: "",
  name: "",
  redirect: "/slot-group",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "",
      component: () => import("@/views/pages/slotgroup"),
      meta: {
        requiresAuth: true,
        activeUrl: "/slot-group",
        parent: "/slot-group",
        lv: level,
      },
    },
    {
      path: "/slot-group/details/:id",
      name: "Slot Group Detail",
      component: () => import("@/views/pages/slotgroup/detail"),
      meta: {
        requiresAuth: true,
        lv: level,
        isChildren: true,
        activeUrl: "/slot-group",
      },
    },
  ],
  meta: { requiresAuth: true },
};
export default Slot;
